<script>

    import {
        orderPlacementResultScreenStore,
        orderConfigStore
    } from "./orders-store.js";
    import Button from "../components/Button.svelte";
    import {closeOrderPlacementResultScreen, screensStore} from "../core/screens-manager.js";
    import { t } from '../core/i18n/language-store';

    function closeScreen () {
        closeOrderPlacementResultScreen();
    }

    function retryPlaceOrder() {}

    function saveMenu () {}
</script>

<style>
    .success-icon {
        color: var(--accent-color);
    }
    .error-icon {
        color: var(--order-error-icon-color);
    }
    h2 {
        margin: 0;
        font-size: 2.625rem;
        line-height: 120%;
        height: 3.875rem;
        padding-top: 0.75rem;
        padding-bottom: 0;
    }
    .success-message, .error-message {
        text-align: center;
        font-size: 1.0625rem;
        color: var(--secondary-font-color);
        width: 70%;
        font-weight: 400;
        line-height: 120%;
    }
    .order-number-title {
        padding-top: 2rem;
        font-size: 1.25rem;
        color: var(--accent-color);
    }
    h3 {
        margin: 0;
        font-size: 2.625rem;
        line-height: 120%;
        padding: .5rem 0;
        color: var(--accent-color);
    }
</style>


{#if ($screensStore.orderPlacementResultOpened)}
    <div class="layer-cart screen-backdrop"></div>
    <button class="screen-close-button pointer" on:click={closeScreen}>
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Cross"><path d="M20 20L4 4m16 0L4 20"/></svg>
    </button>

    <div class="desktop-screen layer-cart screen-content">
        <div class="screen-header">
            <h1>
                {$t('order.title')}
            </h1>
        </div>

        <div class="flex-fill"></div>


        {#if (!$orderPlacementResultScreenStore.error) }

            <!-- SUCCESS -->
            <div class="flex-vertical ai-center jc-center">

                <svg class="success-icon" width="4rem" height="4rem" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.84397 17.8744C3.19397 19.5 5.70497 19.5 10.7292 19.5H11.5392C16.5635 19.5 19.0756 19.5 20.4256 17.8744M1.84397 17.8744C0.493965 16.2476 0.957465 13.7794 1.88334 8.84062C2.54147 5.33062 2.86997 3.5745 4.11984 2.53725M20.4256 17.8744C21.7756 16.2476 21.3121 13.7794 20.3862 8.84062C19.7281 5.33062 19.3985 3.5745 18.1486 2.53725M18.1486 2.53725C16.8998 1.5 15.1122 1.5 11.5403 1.5H10.7281C7.15621 1.5 5.36972 1.5 4.11984 2.53725" stroke="currentColor" stroke-width="1.6875"/>
                    <path d="M7.95068 6C8.18311 6.65872 8.61414 7.22914 9.18436 7.63261C9.75458 8.03609 10.4359 8.25276 11.1344 8.25276C11.833 8.25276 12.5143 8.03609 13.0845 7.63261C13.6547 7.22914 14.0858 6.65872 14.3182 6" stroke="currentColor" stroke-width="1.6875" stroke-linecap="round"/>
                </svg>

                <h2>{$t('order.success.title')}</h2>

                <p class="success-message">
                    {$orderConfigStore.successMessage || $t('order.success.message')}
                </p>

                {#if ($orderPlacementResultScreenStore.orderNumber && $orderConfigStore.showOrderNumber)}
                    <div class="order-number-title">
                        <strong>{$t('order.success.orderNumber')}</strong>
                    </div>

                    <h3>{ $orderPlacementResultScreenStore.orderNumber }</h3>
                {/if}

            </div>
        {:else}
            <!-- ERROR-->

            <div class="flex-vertical ai-center jc-center">

                <svg class="error-icon" width="4rem" height="4rem" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 39.6667H37" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
                    <path d="M37.0002 29C38.4729 29 39.6668 27.2091 39.6668 25C39.6668 22.7909 38.4729 21 37.0002 21C35.5274 21 34.3335 22.7909 34.3335 25C34.3335 27.2091 35.5274 29 37.0002 29Z" fill="currentColor"/>
                    <path d="M21.0002 29C22.4729 29 23.6668 27.2091 23.6668 25C23.6668 22.7909 22.4729 21 21.0002 21C19.5274 21 18.3335 22.7909 18.3335 25C18.3335 27.2091 19.5274 29 21.0002 29Z" fill="currentColor"/>
                    <path d="M2.3335 29C2.3335 16.4293 2.3335 10.144 6.2375 6.23734C10.1468 2.33334 16.4295 2.33334 29.0002 2.33334C41.5708 2.33334 47.8562 2.33334 51.7602 6.23734C55.6668 10.1467 55.6668 16.4293 55.6668 29C55.6668 41.5707 55.6668 47.856 51.7602 51.76C47.8588 55.6667 41.5708 55.6667 29.0002 55.6667C16.4295 55.6667 10.1442 55.6667 6.2375 51.76C2.3335 47.8587 2.3335 41.5707 2.3335 29Z" stroke="currentColor" stroke-width="4"/>
                </svg>

                <h2>{$t('order.error.title')}</h2>

                <p class="error-message">
                    { $orderPlacementResultScreenStore.error }
                </p>
            </div>

        {/if}

        <div class="flex-fill"></div>


        <div class="screen-footer">
            {#if ($orderPlacementResultScreenStore.error)}
            <!-- <Button label="{$t('order.buttons.retry')}" type="secondary" on:clicked={retryPlaceOrder}></Button>-->
            {/if}
            <Button label="{$t('order.buttons.return')}" type="secondary" on:clicked={closeScreen}></Button>
            <!-- <Button label="{$t('order.buttons.save')}" type="secondary" on:clicked={saveMenu}></Button>-->
        </div>

    </div>
{/if}
